'use client';

import dynamic from 'next/dynamic';
import type { HeaderMenuClientProps } from '@/components/layout/HeaderMenuClient';

const HeaderMenuClient = dynamic(() => import('@/components/layout/HeaderMenuClient'), {
  loading: () => (
    <div
      className="relative z-[110] min-h-[56px] w-full animate-pulse bg-white/80 px-4 py-3"
      aria-hidden="true"
    />
  ),
});

export default function HeaderMenuClientDynamic(props: HeaderMenuClientProps) {
  return <HeaderMenuClient {...props} />;
}
